import { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

export const LINKS = [
  { to: '/nfl', label: 'NFL' },
  { to: '/college', label: 'CFB' },
  { to: '/predict', label: 'Predict' },
  { to: '/betting', label: 'Betting' },
  { to: '/grades', label: 'Grades' },
  { to: '/breakdown', label: 'Breakdown' },
];

/** A masthead: wordmark left, sections as an underlined strip, action right. */
export function Nav() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <header className="sticky top-0 z-40 border-b-2 border-ink bg-paper">
        <div className="container flex h-16 items-center justify-between gap-6">
          <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="Kova home">
            <img src="/brand/mark.png" alt="" className="h-9 w-auto" />
            <span className="display text-[24px] leading-none">Kova</span>
          </Link>

          <nav className="hidden h-full items-stretch gap-6 md:flex" aria-label="Primary">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to}
                className={({ isActive }) =>
                  `relative flex items-center font-cond text-[16px] font-semibold uppercase tracking-[0.08em] transition-colors duration-100 ${isActive ? 'text-ink' : 'text-muted hover:text-ink'}
                   after:absolute after:inset-x-0 after:bottom-0 after:h-[3px] after:transition-transform after:duration-150 ${isActive ? 'after:scale-x-100 after:bg-blue' : 'after:scale-x-0 after:bg-blue hover:after:scale-x-100'}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex shrink-0 items-center gap-2">
            <button onClick={() => nav('/ask')} className="btn-primary btn-sm hidden md:inline-flex">Ask Kova</button>
            <button onClick={() => setOpen(true)} className="flex h-10 w-10 flex-col items-center justify-center gap-[5px] md:hidden" aria-label="Menu">
              <span className="h-[2px] w-6 bg-ink" /><span className="h-[2px] w-6 bg-ink" /><span className="h-[2px] w-6 bg-ink" />
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-50 flex flex-col overflow-y-auto bg-ink text-paper">
          <div className="flex h-16 items-center justify-between border-b border-white/15 px-4">
            <img src="/brand/logo-white.png" alt="Kova" className="h-9 w-auto" />
            <button onClick={() => setOpen(false)} className="meta !text-paper/70" aria-label="Close">Close</button>
          </div>
          <nav className="flex flex-col" aria-label="Mobile">
            {[{ to: '/', label: 'Home' }, ...LINKS, { to: '/ask', label: 'Ask Kova' }].map((l, i) => (
              <NavLink key={l.to} to={l.to} end={l.to === '/'} onClick={() => setOpen(false)}
                className={({ isActive }) => `flex items-baseline gap-4 border-b border-white/10 px-4 py-5 ${isActive ? 'text-blue' : 'text-paper'}`}>
                <span className="num text-[12px] text-paper/40">{String(i + 1).padStart(2, '0')}</span>
                <span className="display text-[30px] leading-none">{l.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
